import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { MenuItem } from 'primeng/api';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { InputMaskModule } from 'primeng/inputmask';
import { TooltipModule } from 'primeng/tooltip';

import { AuthService } from '../auth.service';
import { ReportService } from '../report.service';
import { FacesService } from '../faces.service';

import { Photo } from '../photo'
import { DropdownItem } from '../dropdown-item'
import { TimeEntry } from '../time-entry'

declare const require: any;
const jsPDF = require('jspdf');
require('jspdf-autotable');

@Component({
  selector: 'app-facegate-reports',
  templateUrl: './facegate-reports.component.html',
  styleUrls: ['./facegate-reports.component.css']
})
export class FacegateReportsComponent implements OnInit {

  public items: MenuItem[];
  public dateValue: Date;
  public dateValueMod: Date;
  public username: String;
  public employees: Photo[] = [];
  public selectedEmployee: String;
  public selectedEmployeeSingle: String;
  public dipendenti: DropdownItem[] = [];
  public dipendentiSingleReport: DropdownItem[] = [];
  public timetableToMod: String;
  public showTable: Boolean = false;
  public types: any[];
  public numbers: any[];
  public arrotondamento: String = "1";
  public arrotondamentoTipi: any[];
  public display: boolean = false;
  public tabellaModifiche: boolean = false;

        displayDialog: boolean;
        entry: TimeEntry;
        selectedEntry: TimeEntry;
        newEntry: boolean;
        entries: TimeEntry[] = []
        cols: any[] = [
                        { field: 'giorno', header: 'Giorno'},
                        { field: 'modifica', header: 'Mod.', tip:'Data Modifica'},
                        { field: 'ora1', header: 'Ora' },
                        { field: 'tipo1', header: 'Tipo' },
                        { field: 'ora2', header: 'Ora' },
                        { field: 'tipo2', header: 'Tipo' },
                        { field: 'ora3', header: 'Ora' },
                        { field: 'tipo3', header: 'Tipo' },
                        { field: 'ora4', header: 'Ora' },
                        { field: 'tipo4', header: 'Tipo' },
                        { field: 'ora5', header: 'Ora' },
                        { field: 'tipo5', header: 'Tipo' },
                        { field: 'ora6', header: 'Ora' },
                        { field: 'tipo6', header: 'Tipo' },
                        { field: 'ora7', header: 'Ora' },
                        { field: 'tipo7', header: 'Tipo' },
                        { field: 'ora8', header: 'Ora' },
                        { field: 'tipo8', header: 'Tipo' },
                        { field: 'ferie', header: 'Ferie' },
                        { field: 'malattia', header: 'Mal.', tip:'Malattia' },
                      ];


public greenDay:Date;
public today= new Date();

  constructor(
    private router: Router,
    private auth: AuthService,
    private report: ReportService,
    private faces: FacesService,
  ) {
    this.types = [
    {label:'Scegli Tipo', value:null},
    {label:'IN', value:"IN"},
    {label:'OUT', value:"OUT"},
    {label:'SVUOTA', value:"SVUOTA"}
];
    this.numbers = [
      {label:'Select hours', value:null},
      {label:'1', value:"1h"},
      {label:'1:30', value:"1h 30m"},
      {label:'2', value:"2h"},
      {label:'2:30', value:"2h 30m"},
      {label:'3', value:"3h"},
      {label:'3:30', value:"3h 30m"},
      {label:'4', value:"4h"},
      {label:'4:30', value:"4h 30m"},
      {label:'5', value:"5h"},
      {label:'5:30', value:"5h 30m"},
      {label:'6', value:"6h"},
      {label:'6:30', value:"6h 30m"},
      {label:'7', value:"7h"},
      {label:'7:30', value:"7h 30m"},
      {label:'8', value:"8h"},
];
  this.arrotondamentoTipi = [
    {label:'Orario Non Arrotondato', value:"1"},
    {label:'Arrotondato 5m', value:"5"},
    {label:'Arrotondato 10m', value:"10"},
    {label:'Arrotondato 15m', value:"15"},

  ]
  this.dipendenti = [
    {label:'-- Nominativo da modificare --', value:null}
  ]
  this.dipendentiSingleReport = [
    {label:'-- Tutti i nominativi --', value:null}
  ]
  }

  ngOnInit() {
    this.loadFaces();
    this.loadServicesMenu();
  }

  loadFaces() {
    this.auth.getCurrentSession().subscribe(
      currSess => {
        let idToken = currSess.idToken.jwtToken;
        let username = currSess.accessToken.payload.username;
        this.faces.readAllFaces(idToken, username).then(
          employees => {
            this.employees = employees;
            for (let i=0; i<employees.length; i++){
              let a: DropdownItem = {
                value: null,
                label: null
              }
              a.value = this.employees[i].type_key;
              a.label = this.employees[i].cognome + " " + this.employees[i].nome ;
              this.dipendenti.push(a);
              this.dipendentiSingleReport.push(a);

            }
            function compare(a,b) {
              if (a.label < b.label)
                return -1;
              if (a.label > b.label)
                return 1;
              return 0;
            }
            this.dipendenti.sort(compare);
            this.dipendentiSingleReport.sort(compare);
          }
        );
      }
    );

  } // end loadFaces

  loadServicesMenu() {
    this.items = [
      {
        label: 'DATI',
        items: [
          {label: 'I miei dati', icon: 'pi pi-fw pi-file', routerLink: ['/home']},
          {label: 'La mia sottoscrizione', icon: 'pi pi-fw pi-dollar', routerLink:['/payFacegate']}
        ]
      },
      {
        label: 'SERVIZI',
        items: [
          {label: 'Registro foto', icon: 'pi pi-fw pi-camera', routerLink: ['/photosFacegate']},
          {label: 'Dati riepilogativi', icon: 'pi pi-fw pi-users'},
          //{label: 'Configurazione', icon: 'pi pi-fw pi-cog', routerLink: ['/reportConfig']}
        ]
      }
    ];
  } // end loadServicesMenu

  onClickModify(){
    if(this.dateValueMod != undefined && this.selectedEmployee!= undefined){
      console.log("data scelta: " + this.dateValueMod);
      console.log("dipendente scelto " + this.selectedEmployee);
      let employeeWanted = this.selectedEmployee.substring(7);
      let requestedMonth = this.dateValueMod.toString().split(' ');
      this.display=true;
      this.auth.getCurrentSession().subscribe(
        currSess => {
          let idToken = currSess.idToken.jwtToken;
          let username = currSess.accessToken.payload.username;
          if (requestedMonth[1] == "Jan") requestedMonth[1] = "01";
          if (requestedMonth[1] == "Feb") requestedMonth[1] = "02";
          if (requestedMonth[1] == "Mar") requestedMonth[1] = "03";
          if (requestedMonth[1] == "Apr") requestedMonth[1] = "04";
          if (requestedMonth[1] == "May") requestedMonth[1] = "05";
          if (requestedMonth[1] == "Jun") requestedMonth[1] = "06";
          if (requestedMonth[1] == "Jul") requestedMonth[1] = "07";
          if (requestedMonth[1] == "Aug") requestedMonth[1] = "08";
          if (requestedMonth[1] == "Sep") requestedMonth[1] = "09";
          if (requestedMonth[1] == "Oct") requestedMonth[1] = "10";
          if (requestedMonth[1] == "Nov") requestedMonth[1] = "11";
          if (requestedMonth[1] == "Dec") requestedMonth[1] = "12";
          let date = requestedMonth[3] + "-" + requestedMonth[1];
          this.username = username;
          this.report.createReport(idToken, "M", username, date, employeeWanted, "", "1").subscribe(
            data => {
              console.log("Successfull createReport: data = " + JSON.stringify(data, null, 2));
              this.tabellaModifiche = true;
              this.entries = data.modCheck;
              this.display=false;
              document.getElementById("modBox").scrollIntoView();

            },
            error => {
              alert("CREATEREPORT ERROR");
              this.display=false;
              console.log("Failed CREATEREPORT: error = " + JSON.stringify(error, null, 2))
            }
          );
        },
        error => {
          alert("GETCURRENTSESSION ERROR");
          console.log("Failed getCurrentSession: error = " + JSON.stringify(error, null, 2))
        }
      );
    }else alert("Seleziona il mese e il nominativo di cui ti interessa il report.")
  }

  onClickReport() {
    if (this.selectedEmployeeSingle==null){
      if(this.dateValue != undefined){
        console.log("data scelta: " + this.dateValue);
        let requestedMonth = this.dateValue.toString().split(' ');
        this.display=true;
        this.auth.getCurrentSession().subscribe(
          currSess => {
            //console.log("Successfull getCurrentSession: currSess = " + JSON.stringify(currSess, null, 2));
            let idToken = currSess.idToken.jwtToken;
            //console.log("IdToken = " + idToken);
            let username = currSess.accessToken.payload.username;
            if (requestedMonth[1] == "Jan") requestedMonth[1] = "01";
            if (requestedMonth[1] == "Feb") requestedMonth[1] = "02";
            if (requestedMonth[1] == "Mar") requestedMonth[1] = "03";
            if (requestedMonth[1] == "Apr") requestedMonth[1] = "04";
            if (requestedMonth[1] == "May") requestedMonth[1] = "05";
            if (requestedMonth[1] == "Jun") requestedMonth[1] = "06";
            if (requestedMonth[1] == "Jul") requestedMonth[1] = "07";
            if (requestedMonth[1] == "Aug") requestedMonth[1] = "08";
            if (requestedMonth[1] == "Sep") requestedMonth[1] = "09";
            if (requestedMonth[1] == "Oct") requestedMonth[1] = "10";
            if (requestedMonth[1] == "Nov") requestedMonth[1] = "11";
            if (requestedMonth[1] == "Dec") requestedMonth[1] = "12";
            let date = requestedMonth[3] + "-" + requestedMonth[1];
            this.username = username;
            this.report.createReport(idToken, "R", username,date , "", "", this.arrotondamento).subscribe(
              data => {
                console.log("Successfull createReport: data = " + JSON.stringify(data, null, 2));
                //console.log(eval(data[0].timetable)[14])

                var doc = new jsPDF('l');
                var totalPagesExp = "{total_pages_count_string}";
                for(var i = 0; i < data.length; i++) {
                  if(i!=0){
                    doc.addPage();
                  }
                    var obj = data[i];
                    let finalY = 17;

                  doc.text(obj.anagrafica, 14, finalY + 15);
                  doc.autoTable(
                    {
                      styles: {cellPadding: 0.5, fontSize: 9},
                      startY: finalY + 20,
                      head: [
                          ['Giorno', 'Ora', 'Tipo', 'Ora', 'Tipo', 'Ora', 'Tipo', 'Ora', 'Tipo', 'Ora', 'Tipo', 'Ora', 'Tipo', 'Ora', 'Tipo', 'Ora', 'Tipo', 'Parziale', 'Malattia', 'Ferie', 'Modificato', 'TOTALE', 'Green Pass'],
                        ],
                        body : eval(obj.timetable),
                        didDrawPage: function (data) {
                          // Header
                          doc.setFontSize(20);
                          doc.setTextColor(40);
                          doc.setFontStyle('calibri');
                          /*if (base64Img) {
                          doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10);
                        }*/
                        doc.text(username, data.settings.margin.left, 22);
                        doc.text("Report " + requestedMonth[1] + ' ' + requestedMonth[3], 120, 22)
                        var currentDate = new Date();
                        var day = currentDate.getDate()
                        var month = currentDate.getMonth() + 1
                        var year = currentDate.getFullYear()
                        doc.setFontSize(10);
                        doc.text(day + "/" + month + "/" + year, 268, 20)
                      // Footer
                        var str = "Page " + doc.internal.getNumberOfPages()
                      // Total page number plugin only available in jspdf v1.0+
                        if (typeof doc.putTotalPages === 'function') {
                          str = str + " of " + totalPagesExp;
                        }
                        doc.setFontSize(10);

                      // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                        var pageSize = doc.internal.pageSize;
                        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                        doc.text(str, data.settings.margin.left, pageHeight - 10);
                      },
                    })
                }
                if (typeof doc.putTotalPages === 'function') {
                  doc.putTotalPages(totalPagesExp);
                }
                doc.save('table.pdf');
                this.display=false;
                },
              error => {
                alert("CREATEREPORT ERROR");
                this.display=false;
                console.log("Failed CREATEREPORT: error = " + JSON.stringify(error, null, 2))
              }
            );
            },
            error => {
              alert("GETCURRENTSESSION ERROR");
              console.log("Failed getCurrentSession: error = " + JSON.stringify(error, null, 2))
            }
          );
        }else alert("Seleziona il mese di cui ti interessa il report.")
      } else {
        if(this.dateValue != undefined && this.selectedEmployeeSingle!= undefined){
          console.log("data scelta: " + this.dateValue);
          console.log("dipendente scelto " + this.selectedEmployeeSingle);
          let employeeWanted = this.selectedEmployeeSingle.substring(7);
          let requestedMonth = this.dateValue.toString().split(' ');
          this.display=true;
          this.auth.getCurrentSession().subscribe(
            currSess => {
              let idToken = currSess.idToken.jwtToken;
              let username = currSess.accessToken.payload.username;
              if (requestedMonth[1] == "Jan") requestedMonth[1] = "01";
              if (requestedMonth[1] == "Feb") requestedMonth[1] = "02";
              if (requestedMonth[1] == "Mar") requestedMonth[1] = "03";
              if (requestedMonth[1] == "Apr") requestedMonth[1] = "04";
              if (requestedMonth[1] == "May") requestedMonth[1] = "05";
              if (requestedMonth[1] == "Jun") requestedMonth[1] = "06";
              if (requestedMonth[1] == "Jul") requestedMonth[1] = "07";
              if (requestedMonth[1] == "Aug") requestedMonth[1] = "08";
              if (requestedMonth[1] == "Sep") requestedMonth[1] = "09";
              if (requestedMonth[1] == "Oct") requestedMonth[1] = "10";
              if (requestedMonth[1] == "Nov") requestedMonth[1] = "11";
              if (requestedMonth[1] == "Dec") requestedMonth[1] = "12";
              let date = requestedMonth[3] + "-" + requestedMonth[1];
              this.username = username;
              this.report.createReport(idToken, "S", username, date, employeeWanted, "", "1").subscribe(
                data => {
                  console.log("Successfull createReport: data = " + JSON.stringify(data, null, 2));
                  var doc = new jsPDF('l');
                  var totalPagesExp = "{total_pages_count_string}";
                  for(var i = 0; i < data.length; i++) {
                    if(i!=0){
                      doc.addPage();
                    }
                      var obj = data[i];
                      let finalY = 17;

                    doc.text(obj.anagrafica, 14, finalY + 15);
                    doc.autoTable(
                      {
                        styles: {cellPadding: 0.5, fontSize: 9},
                        startY: finalY + 20,
                        head: [
                            ['Giorno', 'Ora', 'Tipo', 'Ora', 'Tipo', 'Ora', 'Tipo', 'Ora', 'Tipo', 'Ora', 'Tipo', 'Ora', 'Tipo', 'Ora', 'Tipo', 'Ora', 'Tipo', 'Parziale', 'Malattia', 'Ferie', 'Modificato', 'TOTALE', 'GREEN PASS'],
                          ],
                          body : eval(obj.timetable),
                          didDrawPage: function (data) {
                            // Header
                            doc.setFontSize(20);
                            doc.setTextColor(40);
                            doc.setFontStyle('calibri');
                            /*if (base64Img) {
                            doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10);
                          }*/
                          doc.text(username, data.settings.margin.left, 22);
                          doc.text("Report " + requestedMonth[1] + ' ' + requestedMonth[3], 120, 22)
                          var currentDate = new Date();
                          var day = currentDate.getDate()
                          var month = currentDate.getMonth() + 1
                          var year = currentDate.getFullYear()
                          doc.setFontSize(10);
                          doc.text(day + "/" + month + "/" + year, 268, 20)
                        // Footer
                          var str = "Page " + doc.internal.getNumberOfPages()
                        // Total page number plugin only available in jspdf v1.0+
                          if (typeof doc.putTotalPages === 'function') {
                            str = str + " of " + totalPagesExp;
                          }
                          doc.setFontSize(10);

                        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                          var pageSize = doc.internal.pageSize;
                          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                          doc.text(str, data.settings.margin.left, pageHeight - 10);
                        },
                      })
                  }
                  if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp);
                  }
                  doc.save('table.pdf');
                  this.display=false;
                  },
                error => {
                  alert("CREATEREPORT ERROR");
                  this.display=false;
                  console.log("Failed CREATEREPORT: error = " + JSON.stringify(error, null, 2))
                }
              );
            },
            error => {
              alert("GETCURRENTSESSION ERROR");
              console.log("Failed getCurrentSession: error = " + JSON.stringify(error, null, 2))
            }
          );
        }else alert("Seleziona il mese e il nominativo di cui ti interessa il report.")
      }
  }

  onClickUpdate(){
    let entries = [...this.entries];
    this.removeEmpty(entries);
    console.log(JSON.stringify(entries))
    let employeeWanted = this.selectedEmployee.substring(7);
    let requestedMonth = this.dateValueMod.toString().split(' ');
    this.display=true;
    this.auth.getCurrentSession().subscribe(
      currSess => {
        let idToken = currSess.idToken.jwtToken;
        let username = currSess.accessToken.payload.username;
        if (requestedMonth[1] == "Jan") requestedMonth[1] = "01";
        if (requestedMonth[1] == "Feb") requestedMonth[1] = "02";
        if (requestedMonth[1] == "Mar") requestedMonth[1] = "03";
        if (requestedMonth[1] == "Apr") requestedMonth[1] = "04";
        if (requestedMonth[1] == "May") requestedMonth[1] = "05";
        if (requestedMonth[1] == "Jun") requestedMonth[1] = "06";
        if (requestedMonth[1] == "Jul") requestedMonth[1] = "07";
        if (requestedMonth[1] == "Aug") requestedMonth[1] = "08";
        if (requestedMonth[1] == "Sep") requestedMonth[1] = "09";
        if (requestedMonth[1] == "Oct") requestedMonth[1] = "10";
        if (requestedMonth[1] == "Nov") requestedMonth[1] = "11";
        if (requestedMonth[1] == "Dec") requestedMonth[1] = "12";
        let date = requestedMonth[3] + "-" + requestedMonth[1];
        this.username = username;
        this.report.createReport(idToken, "T", username, date, employeeWanted, entries, "1").subscribe(
          data => {
            console.log("Successfull update")
            //this.onClickModify();
            this.display=false;
            this.tabellaModifiche = false;
            alert("Modifiche effettuate con successo")
          },
          error => {
            alert("UPDATEREPORT ERROR");
            this.display=false;
            console.log("Failed CREATEREPORT: error = " + JSON.stringify(error, null, 2))
          }
        );
      },
      error => {
        alert("GETCURRENTSESSION ERROR");
        console.log("Failed getCurrentSession: error = " + JSON.stringify(error, null, 2))
      }
    );
  }

  onClickClose(){
    this.tabellaModifiche = false;
  }

  showDialogToAdd() {
      this.newEntry = true;
      this.entry = null;
      this.displayDialog = true;

  }

  tableSave() {
      let entries = [...this.entries];
      if (this.newEntry){
          this.convertTime(this.entry.ora1);
          this.convertTime(this.entry.ora2);
          this.convertTime(this.entry.ora3);
          this.convertTime(this.entry.ora4);
          this.convertTime(this.entry.ora5);
          this.convertTime(this.entry.ora6);
          this.convertTime(this.entry.ora7);
          this.convertTime(this.entry.ora8);
          entries.push(this.entry);
        }
      else
          entries[this.entries.indexOf(this.selectedEntry)] = this.entry;

      if (this.entry.tipo1 == "SVUOTA"){
        this.entry.tipo1=null;
        this.entry.ora1=null;
      }
      if (this.entry.tipo2 == "SVUOTA"){
        this.entry.tipo2=null;
        this.entry.ora2=null;
      }
      if (this.entry.tipo3 == "SVUOTA"){
        this.entry.tipo3=null;
        this.entry.ora3=null;
      }
      if (this.entry.tipo4 == "SVUOTA"){
        this.entry.tipo4=null;
        this.entry.ora4=null;
      }
      if (this.entry.tipo5 == "SVUOTA"){
        this.entry.tipo5=null;
        this.entry.ora5=null;
      }
      if (this.entry.tipo6 == "SVUOTA"){
        this.entry.tipo6=null;
        this.entry.ora6=null;
      }
      if (this.entry.tipo7 == "SVUOTA"){
        this.entry.tipo7=null;
        this.entry.ora7=null;
      }
      if (this.entry.tipo8 == "SVUOTA"){
        this.entry.tipo8=null;
        this.entry.ora8=null;
      }

      this.entries = entries;
      this.entry = null;
      this.displayDialog = false;
  }

  tableAnnulla() {
    this.displayDialog = false;
  }

  onRowSelect(event) {
      this.newEntry = false;
      this.entry = this.cloneEntry(event.data);
      this.displayDialog = true;
      var currentDate = new Date();
      var day = currentDate.getDate()
      var month = currentDate.getMonth() + 1
      var year = currentDate.getFullYear()
      this.entry.modifica =  day + "/" + month; //+ "/" + year;
  }

  cloneEntry(e: TimeEntry): TimeEntry {
      let entry = {
          "giorno":"",
          "modifica":"",
          "ora1":"",
          "tipo1":"",
          "ora2":"",
          "tipo2":"",
          "ora3":"",
          "tipo3":"",
          "ora4":"",
          "tipo4":"",
          "ora5":"",
          "tipo5":"",
          "ora6":"",
          "tipo6":"",
          "ora7":"",
          "tipo7":"",
          "ora8":"",
          "tipo8":"",
          "ferie":"",
          "malattia":""
      };
      for (let prop in e) {
          entry[prop] = e[prop];
      }
      return entry;
  }

  convertTime(str:string) {
      var date = new Date(str),
      mnth = ("0" + (date.getMonth()+1)).slice(-2),
      day  = ("0" + date.getDate()).slice(-2),
      hours  = ("0" + date.getHours()).slice(-2),
      minutes = ("0" + date.getMinutes()).slice(-2);
      return [hours, minutes].join(":");
  }

  removeEmpty(entries){
    let keys = Object.keys(entries)
    console.log(keys)
  }

  parseData(modReport){
  }

  onClickReportGreenpass() {
      if(this.greenDay != undefined){
        console.log("data scelta: " + this.greenDay);
        let requestedMonth = this.greenDay.getMonth();
        let requestedDay = this.greenDay.getDate();
        let requestedYear = this.greenDay.getFullYear();

        let requestedMonthString

        this.display=true;
        this.auth.getCurrentSession().subscribe(
          currSess => {
            //console.log("Successfull getCurrentSession: currSess = " + JSON.stringify(currSess, null, 2));
            let idToken = currSess.idToken.jwtToken;
            //console.log("IdToken = " + idToken);
            let username = currSess.accessToken.payload.username;
            if (requestedMonth == 0) requestedMonthString = "01";
            if (requestedMonth == 1) requestedMonthString = "02";
            if (requestedMonth == 2) requestedMonthString = "03";
            if (requestedMonth == 3) requestedMonthString = "04";
            if (requestedMonth == 4) requestedMonthString = "05";
            if (requestedMonth == 5) requestedMonthString = "06";
            if (requestedMonth == 6) requestedMonthString = "07";
            if (requestedMonth == 7) requestedMonthString = "08";
            if (requestedMonth == 8) requestedMonthString = "09";
            if (requestedMonth == 9) requestedMonthString = "10";
            if (requestedMonth == 10) requestedMonthString = "11";
            if (requestedMonth == 11) requestedMonthString = "12";
            let date = requestedYear.toString() + "-" + requestedMonthString;
            this.username = username;
            this.report.createReport(idToken, "R", username,date , "", "", this.arrotondamento).subscribe(
              data => {
                console.log("Successfull createReport: data = " + JSON.stringify(data, null, 2));

                var greencheck = "Report Greenpass; " + requestedDay + "/" + requestedMonthString + "/" + requestedYear + ";\n\n";
                var greenDay = requestedDay - 1;

                data.forEach(obj =>{
                  var persona = obj;
                  var nome = obj.anagrafica;
                  var time = eval(persona.timetable);
                  console.log(nome + " " + time[greenDay]);
                  if(time[greenDay].toString().length>=6){
                    greencheck += (nome + ";" + time[greenDay].toString().split(',')[22] + ";\n");
                  }
                })

                //alert(greencheck);
                var fileName = "reportGP_" + requestedDay + "_" + requestedMonthString + "_" + requestedYear
                this.downloadFile(greencheck, fileName);

                //console.log(eval(data[0].timetable)[14])

                // var doc = new jsPDF('l');
                // var totalPagesExp = "{total_pages_count_string}";
                // for(var i = 0; i < data.length; i++) {
                //   if(i!=0){
                //     doc.addPage();
                //   }
                //     var obj = data[i];
                //     let finalY = 17;
                //
                //   doc.text(obj.anagrafica, 14, finalY + 15);
                //   doc.autoTable(
                //     {
                //       styles: {cellPadding: 0.5, fontSize: 9},
                //       startY: finalY + 20,
                //       head: [
                //           ['Giorno', 'Ora', 'Tipo', 'Ora', 'Tipo', 'Ora', 'Tipo', 'Ora', 'Tipo', 'Ora', 'Tipo', 'Ora', 'Tipo', 'Ora', 'Tipo', 'Ora', 'Tipo', 'Parziale', 'Malattia', 'Ferie', 'Modificato', 'TOTALE', 'Green Pass'],
                //         ],
                //         body : eval(obj.timetable),
                //         didDrawPage: function (data) {
                //           // Header
                //           doc.setFontSize(20);
                //           doc.setTextColor(40);
                //           doc.setFontStyle('calibri');
                //           /*if (base64Img) {
                //           doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10);
                //         }*/
                //         doc.text(username, data.settings.margin.left, 22);
                //         doc.text("Report " + requestedMonth[1] + ' ' + requestedMonth[3], 120, 22)
                //         var currentDate = new Date();
                //         var day = currentDate.getDate()
                //         var month = currentDate.getMonth() + 1
                //         var year = currentDate.getFullYear()
                //         doc.setFontSize(10);
                //         doc.text(day + "/" + month + "/" + year, 268, 20)
                //       // Footer
                //         var str = "Page " + doc.internal.getNumberOfPages()
                //       // Total page number plugin only available in jspdf v1.0+
                //         if (typeof doc.putTotalPages === 'function') {
                //           str = str + " of " + totalPagesExp;
                //         }
                //         doc.setFontSize(10);
                //
                //       // jsPDF 1.4+ uses getWidth, <1.4 uses .width
                //         var pageSize = doc.internal.pageSize;
                //         var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                //         doc.text(str, data.settings.margin.left, pageHeight - 10);
                //       },
                //     })
                // }
                // if (typeof doc.putTotalPages === 'function') {
                //   doc.putTotalPages(totalPagesExp);
                // }
                // doc.save('table.pdf');
                this.display=false;
                },
              error => {
                alert("CREATEREPORT ERROR");
                this.display=false;
                console.log("Failed CREATEREPORT: error = " + JSON.stringify(error, null, 2))
              }
            );
            },
            error => {
              alert("GETCURRENTSESSION ERROR");
              console.log("Failed getCurrentSession: error = " + JSON.stringify(error, null, 2))
            }
          );
        }else alert("Seleziona il giorno di cui ti interessa il report.")
  }

  downloadFile(csvData, filename = 'data') {
    console.log(csvData)
    let blob = new Blob(['\ufeff' + csvData], {
        type: 'text/csv;charset=utf-8;'
    });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 &&
    navigator.userAgent.indexOf('Chrome') == -1;

    //if Safari open in new window to save file with random filename.
    if (isSafariBrowser) {
        dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

}
